import { atom } from 'recoil';

export const session = atom({
  key: 'session',
  default: {
    user: {},
    session: false,
    loaded: false,
    error: false,
    loggedOut: false,
    exception: ''
  }
});

export default session;
